<template>
  <div>
    <el-dropdown trigger="click" placement="bottom-start" v-show="permission && permission.edit" @visible-change="loadList()">
      <el-button type="primary" size="small" icon="el-icon-right">
        移動
        <font-awesome-icon icon="caret-down" style="margin-left:5px" />
      </el-button>
      <el-dropdown-menu slot="dropdown" class="list-select">
        <div class="dropdown-search">
          <el-input class="dropdown-input" placeholder="リストを検索" prefix-icon="el-icon-search" size="large" clearable v-model="search_word" @input="loadList()"></el-input>
        </div>
        <el-dropdown-item class="add-list-dropdown" @click.native="openConfirmModal(list.list_id, list.list_name)" v-for="list in this.list" :key="list.id" v-show="list.list_id != list_id">
          <div class="flex-row">
            <font-awesome-icon :icon="['fab', list.sns_type]" style="margin-right:5px" />
            <div class="dropdown_listname">{{ list.list_name }}</div>
            <div class="flex-space"></div>
            <span>{{ list.influencer_num }}</span>
          </div>
        </el-dropdown-item>
        <div v-show="result_count == 0 && !loading" class="add-list-dropdown-nolist">リストがありません</div>
        <infinite-loading spinner="spiral" :identifier="infiniteId" @infinite="infiniteHandler">
          <div slot="no-more"></div>
          <div slot="no-results" style="font-size:40px;"></div>
        </infinite-loading>
        <div style="padding-bottom: 10px"></div>
      </el-dropdown-menu>
    </el-dropdown>

    <el-button type="primary" size="small" icon="el-icon-right" v-show="permission && !permission.edit" @click="openUnpermitted()">
      移動
      <font-awesome-icon icon="caret-down" style="margin-left:5px" />
    </el-button>

    <transition name="fade">
      <div class="phrase-overlay" v-if="confirm" @click.self="confirm = false">
        <div class="create-phrase-wrap w-480">
          <div class="list-create">
            <div class="newmessage-title">
              インフルエンサーを移動
              <div class="flex-space"></div>
              <div class="newmessage-button" @click="confirm = false">
                <font-awesome-icon :icon="['fal', 'times']" />
              </div>
            </div>
            <div class="list-create-message">
              <div><font-awesome-icon :icon="['fas', 'exclamation-circle']" style="color:#888; font-size:24px" /></div>
              <div>{{ checkList.length }}名のインフルエンサーを「{{ target_list_name }}」に移動しますか？</div>
            </div>
            <div class="list-create-footer">
              <div class="flex-space"></div>
              <el-button @click="confirm = false">キャンセル</el-button>
              <el-button
                id="ok-button"
                type="primary"
                :disabled="move_loading"
                @click="moveInfluencer(target_list_id, target_list_name, checkList.length)"
                @keydown.enter="moveInfluencer(target_list_id, target_list_name, checkList.length)"
                @keydown.esc="confirm = false"
              >
                <div class="flex-row">
                  OK
                  <div class="loader--mini" v-show="move_loading"></div>
                </div>
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const loadListAPI = root + "/api/list/load_list";
const moveInfluencerAPI = root + "/api/list/move_influencer";

export default {
  name: "moveListButton",
  props: ["checkList", "sns_type", "list_id"],
  components: {},
  data() {
    return {
      list: [],
      result_count: 0,
      active_list_count: "",
      search_word: "",
      offset: 0,
      infiniteId: +new Date(),
      requestId: +new Date() + 10000,
      loading: false,
      confirm: false,
      move_loading: false,
      target_list_id: "",
      target_list_name: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    permission() {
      return this.$store.state.permission.list;
    },
    activate() {
      return this.$store.state.activate;
    },
  },
  mounted() {
    this.loadList();
    this.addKeyDown();
  },
  methods: {
    infiniteHandler($state) {
      if (this.permission && this.permission.edit) {
        this.loading = true;
        this.axios.cancel(this.requestId);
        this.requestId += 1;
        this.axios
          .get(loadListAPI, {
            requestId: this.requestId,
            params: {
              token: this.token,
              type: "min",
              offset: this.offset,
              search_word: this.search_word,
              sns_type: this.sns_type,
            },
          })
          .then((response) => {
            if (this.offset == 0) {
              this.list = response.data.mylist;
              this.result_count = response.data.result_count;
              this.active_list_count = response.data.active_list_count;
            } else {
              this.list = this.list.concat(response.data.mylist);
            }
            $state.loaded();
            this.offset += 40;
            this.loading = false;
            if (this.result_count <= this.offset) $state.complete();
          });
      }
    },
    loadList() {
      this.list = [];
      this.offset = 0;
      this.result_count = 0;
      this.infiniteId += 1;
    },
    openConfirmModal(list_id, list_name) {
      this.target_list_id = list_id;
      this.target_list_name = list_name;
      this.confirm = true;
      setTimeout(() => {
        this.focusOK();
      }, 200);
    },
    moveInfluencer(id, name, num) {
      this.$message({
        type: "info",
        duration: 0,
        offset: 7,
        showClose: true,
        dangerouslyUseHTMLString: true,
        message: 'インフルエンサーを移動中です<div class="loader--mini"></div>',
      });
      var params = new URLSearchParams();
      params.append("list_id_old", this.list_id);
      params.append("list_id_new", id);
      params.append("sns_type", this.sns_type);
      params.append("influencer", JSON.stringify(this.checkList));
      params.append("token", this.token);
      this.axios.post(moveInfluencerAPI, params).then(() => {
        this.$emit("loadQuery");
        this.$emit("loadList");
        this.$emit("loadListDetail");
        this.$emit("refreshInfluencerUpdateStatus");
        this.$emit("update:checkList", []);
        this.$message.closeAll();
        this.$message({
          type: "success",
          offset: 7,
          showClose: true,
          message: num + "名のインフルエンサーを" + name + "に移動しました",
        }).catch(() => {
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "インフルエンサーの移動に失敗しました",
          });
        });
        this.move_loading = false;
        this.confirm = false;
      });
      this.move_loading = false;
      this.confirm = false;
    },
    openUnpermitted() {
      this.$store.dispatch("openUnpermittedDrawer", true);
    },
    focusOK() {
      document.getElementById("ok-button").focus();
    },
    addKeyDown() {
      document.addEventListener("keydown", this.onKeyDown);
    },
    removeKeyDown() {
      document.removeEventListener("keydown", this.onKeyDown);
    },
    onKeyDown(event) {
      if (event.key == "Escape") this.confirm = false;
    },
  },
  beforeDestroy() {
    this.removeKeyDown();
  },
};
</script>
